// assets/jb-calc.js
(function () {
  /* ---------- Utils ---------- */
  function safeParse(s) { try { return JSON.parse(s); } catch { return {}; } }
  function debounce(fn, delay) { let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), delay); }; }
  function isValidEmail(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e).trim()); }

  /* ---------- Enhance one calculator root ---------- */
  function enhance(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    const cfg = safeParse(root.dataset.config || '{}');
    if (!cfg || Object.keys(cfg).length === 0) {
      console.warn('JB Calc: missing product pricing metafield (custom.b2b_pricing). Skipping.');
      return;
    }
    const PRICING = cfg;

    const MAX_SHOWN_QTY = 500;

    const $ = (sel) => root.querySelector(sel);
    const elCurrency   = $('#jb-calc-currency');
    const elQty        = $('#jb-calc-qty');
    const elPrint      = $('#jb-calc-print');
    const elUnit       = $('#jb-calc-unit');
    const elTotal      = $('#jb-calc-total');
    const elImpact     = $('#jb-calc-impact');
    const elExVat      = $('#jb-exvat');
    const elRrpRow     = $('#jb-rrp-row');
    const elRrp        = $('#jb-calc-rrp');
    const coBrandPill  = $('#jb-cobrand-pill');
    const elTiersToggle = $('#jb-tiers-toggle');
    const elTiersPanel = $('#jb-tiers-panel');
    const elTiersList  = $('#jb-tiers-list');

    /* ---------- Persist user choices per product ---------- */
    const storageKey = (function(){
      function getProductKey(){
        const cands = [
          root.dataset.productId,
          root.dataset.productHandle,
          window.ShopifyAnalytics?.meta?.product?.id,
          window.ShopifyAnalytics?.meta?.product?.handle,
          window.meta?.product?.id,
          window.meta?.product?.handle
        ].filter(Boolean);
        if (cands.length) return String(cands[0]);
        try {
          const m = location.pathname.match(/\/products\/([^\/?#]+)/i);
          if (m) return decodeURIComponent(m[1]);
        } catch {}
        return location.pathname || 'global';
      }
      return `jbcalc:v2:${getProductKey()}`;
    })();
    let prefs = {};
    try { prefs = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch {}
    function persist(){
      try {
        const data = {
          cur:   elCurrency?.value || '',
          qty:   elQty?.value || '',
          print: elPrint?.value || ''
        };
        localStorage.setItem(storageKey, JSON.stringify(data));
      } catch {}
    }

    /* ---------- Email Gate ---------- */
    const gateEnabled = (root.dataset.gate || '').toLowerCase() === 'email';
    const productKey = 'sitewide';
    const gateKey  = `jbcalc:gate:${productKey}`;
    const emailKey = `jbcalc:email:${productKey}`;
    const UNLOCK_EVENT_KEY = 'jbcalc:ga:pricing_unlocked';

    function addPricingUnlockedParam() {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('pricing_unlocked', '1');
        history.replaceState({}, '', url.toString());
      } catch {}
    }

    function firePricingUnlockedEventOnce() {
      try {
        if (localStorage.getItem(UNLOCK_EVENT_KEY) === '1') return;
        localStorage.setItem(UNLOCK_EVENT_KEY, '1');
      } catch {}
    }

    function unlockGate() {
      try { localStorage.setItem(gateKey, '1'); } catch{}
      root.classList.remove('jb-gated');
      gateEl?.remove();
    }

    function notifyOwner(email){
      const title  = root.dataset.productTitle
                  || window.meta?.product?.title
                  || document.querySelector('meta[property="og:title"]')?.content
                  || document.title;
      const handle = root.dataset.productHandle || window.meta?.product?.handle || '';
      const msg = [
        'B2B calculator unlocked',
        `Email: ${email}`,
        `Product: ${title}`,
        `Handle: ${handle}`,
        `URL: ${location.href}`,
        `Time: ${new Date().toISOString()}`
      ].join('\n');

      const params = new URLSearchParams();
      params.set('form_type','contact');
      params.set('utf8','✓');
      params.set('contact[email]', email);
      params.set('contact[body]', msg);

      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: params.toString(),
        credentials: 'same-origin',
        keepalive: true
      }).catch(()=>{});
    }

    let gateEl = null;
    if (gateEnabled && localStorage.getItem(gateKey) !== '1') {
      root.classList.add('jb-gated');

      // Get dynamic values for teaser
      const { moq, firstDiscountTier } = getQtyConfig();
      const maxDiscount = (function() {
        const firstCur = currencyKeys()[0];
        if (!firstCur || !PRICING[firstCur]) return 0;
        const meta = PRICING[firstCur];
        const rrp = meta.rrp || 0;
        if (!rrp) return 0;
        const tiers = Object.keys(meta.unit).map(Number).sort((a, b) => a - b);
        const lowestPrice = tiers.length ? meta.unit[tiers[tiers.length - 1]] : 0;
        if (!lowestPrice || lowestPrice >= rrp) return 0;
        return Math.round(((rrp - lowestPrice) / rrp) * 100);
      })();

      gateEl = document.createElement('div');
      gateEl.className = 'jb-gate';
      gateEl.innerHTML = `
        <div class="jb-gate-card" role="dialog" aria-modal="true" aria-labelledby="jb-gate-title">
          <div class="jb-gate-badge">B2B Pricing</div>
          <h4 id="jb-gate-title" class="jb-gate-title">View Trade Pricing</h4>
          
          <div class="jb-gate-benefits">
            ${maxDiscount > 0 ? `
            <div class="jb-gate-benefit">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Unit prices <strong>up to ${maxDiscount}% below RRP</strong></span>
            </div>
            ` : ''}
            <div class="jb-gate-benefit">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Volume discounts from <strong>${firstDiscountTier} units</strong></span>
            </div>
            <div class="jb-gate-benefit">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <span><strong>Free shipping</strong> & no hidden fees</span>
            </div>
          </div>

          <p class="jb-gate-sub">Enter your work email for instant access</p>
          <div class="jb-gate-row">
            <input type="email" class="jb-gate-input" placeholder="name@company.com" autocomplete="email" required>
            <button class="jb-gate-btn" type="button">View Pricing</button>
          </div>
          <div class="jb-gate-error" aria-live="polite"></div>
          
          <div class="jb-gate-trust">
            <span class="jb-gate-trust-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              Instant access
            </span>
            <span class="jb-gate-trust-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
              30,000+ products sold
            </span>
          </div>
        </div>
      `;
      root.appendChild(gateEl);

      const emailInput = gateEl.querySelector('.jb-gate-input');
      const btn        = gateEl.querySelector('.jb-gate-btn');
      const err        = gateEl.querySelector('.jb-gate-error');

      const submit = async () => {
        const email = String(emailInput.value || '').trim();
        if (!isValidEmail(email)) { err.textContent = 'Please enter a valid email'; emailInput.focus(); return; }
        err.textContent = ''; btn.disabled = true;
        try { localStorage.setItem(emailKey, email); } catch {}
        notifyOwner(email);
        unlockGate();
        addPricingUnlockedParam();
        firePricingUnlockedEventOnce();
      };

      btn.addEventListener('click', submit);
      emailInput.addEventListener('keydown', (e)=>{ if (e.key === 'Enter') submit(); });
    }

    if (gateEnabled && localStorage.getItem(gateKey) === '1') {
      addPricingUnlockedParam();
    }

    /* ---------- Currency select ---------- */
    function currencyKeys() {
      return Object.keys(PRICING).filter(k => PRICING[k] && typeof PRICING[k] === 'object' && PRICING[k].unit);
    }
    function currencyLabel(code, meta) {
      const c = (meta && meta.code) ? meta.code : code;
      const locale = meta && meta.locale ? meta.locale : undefined;
      try {
        const nf = new Intl.NumberFormat(locale, { style: 'currency', currency: c, currencyDisplay: 'symbol' });
        const parts = nf.formatToParts(0);
        const sym = parts.find(p => p.type === 'currency')?.value;
        return sym ? `${code} ${sym}` : code;
      } catch {
        return code;
      }
    }
    function buildCurrencySelect() {
      if (!elCurrency) return;
      elCurrency.innerHTML = '';
      const codes = currencyKeys();
      codes.forEach(code => {
        const opt = document.createElement('option');
        opt.value = code;
        opt.textContent = currencyLabel(code, PRICING[code]);
        elCurrency.appendChild(opt);
      });

      // Priority: saved pref -> detected market currency -> GBP -> first
      const saved = (prefs.cur || '').toUpperCase();
      const detected = (root.dataset.defaultCurrency || '').toUpperCase();
      
      if (saved && codes.includes(saved)) {
        elCurrency.value = saved;
      } else if (detected && codes.includes(detected)) {
        elCurrency.value = detected;
      } else if (codes.includes('GBP')) {
        elCurrency.value = 'GBP';
      } else {
        elCurrency.value = codes[0] || '';
      }
    }
    buildCurrencySelect();

    /* ---------- Extract MOQ from metafield ---------- */
    function getQtyConfig() {
      const firstCur = currencyKeys()[0];
      if (!firstCur || !PRICING[firstCur]?.unit) return { moq: 25, tiers: [], firstDiscountTier: 50 };
      
      const tiers = Object.keys(PRICING[firstCur].unit).map(Number).sort((a, b) => a - b);
      const moq = tiers[0] || 25;
      const firstDiscountTier = tiers.length > 1 ? tiers[1] : moq;
      
      return { moq, tiers, firstDiscountTier };
    }

    /* ---------- Quantity select: build dynamically from metafield ---------- */
    function buildQtySelect() {
      if (!elQty) return;
      
      const { moq } = getQtyConfig();
      const batch = moq; // Use MOQ as the increment (e.g., 25 → 25, 50, 75...)
      
      elQty.innerHTML = '';
      
      // Build options from MOQ to MAX_SHOWN_QTY in batch increments
      for (let qty = moq; qty <= MAX_SHOWN_QTY; qty += batch) {
        const opt = document.createElement('option');
        opt.value = String(qty);
        opt.textContent = String(qty);
        elQty.appendChild(opt);
      }
      
      // Add 500+ option
      const plusOpt = document.createElement('option');
      plusOpt.value = '500plus';
      plusOpt.textContent = '500+ (larger volumes)';
      elQty.appendChild(plusOpt);
      
      // Restore saved preference or default to 2nd option
      const savedQty = prefs.qty;
      const options = [...elQty.options].map(o => o.value);
      
      if (savedQty && options.includes(savedQty)) {
        elQty.value = savedQty;
      } else if (options.length > 1) {
        elQty.value = options[1]; // Default to 2nd tier (e.g., 50)
      } else {
        elQty.value = options[0];
      }
      
      // Update the label to show correct MOQ
      const qtyLabel = root.querySelector('#jb-calc-qty-label');
      if (qtyLabel) {
        qtyLabel.textContent = `Quantity (MOQ ${moq})`;
      }
    }
    buildQtySelect();

    /* ---------- Print select ---------- */
    function getPrintKeys() {
      const sets = currencyKeys().map(k => Object.keys((PRICING[k]||{}).surcharge || {}));
      return Array.from(new Set(sets.flat()));
    }
    const PRINT_LABELS = (PRICING.labels && PRICING.labels.prints) || {
      laser: 'Laser Engrave',
      colour: 'ColourLift™ Print',
      wrap: 'Wrap Printing',
      multicolour: 'Multi colour print'
    };
    const PRINT_TIPS = (PRICING.tooltips && PRICING.tooltips.prints) || {
      laser: 'Exposes the stainless steel below',
      colour: 'Premium quality print for single colour designs',
      wrap: '360 degree printing around the cup',
      multicolour: 'Limitless colour printing'
    };
    function labelForPrint(key){
      return PRINT_LABELS[key] || key.replace(/_/g,' ').replace(/\b\w/g, m => m.toUpperCase());
    }
    function buildPrintSelect(){
      if (!elPrint) return;
      const keys = getPrintKeys();
      if (!keys.length) return;
      elPrint.innerHTML = '';
      keys.forEach(k => {
        const opt = document.createElement('option');
        opt.value = k;
        opt.textContent = labelForPrint(k);
        elPrint.appendChild(opt);
      });
      if (prefs.print && keys.includes(prefs.print)) {
        elPrint.value = prefs.print;
      } else if (keys.includes('laser')) {
        elPrint.value = 'laser';
      } else {
        elPrint.value = keys[0];
      }
    }
    buildPrintSelect();

    /* ---------- Print tooltip ---------- */
    const printLabelSpan = elPrint ? elPrint.closest('label')?.querySelector('.jb-calc-label') : null;
    let tipBtn, tipBubble;

    function buildTipContent() {
      const keys = getPrintKeys();
      const items = keys.map(k => {
        const name = labelForPrint(k);
        const blurb = PRINT_TIPS[k] || 'Details available on request.';
        const esc = (s)=>String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
        return `<li><strong>${esc(name)}:</strong> ${esc(blurb)}</li>`;
      }).join('');
      return `<ul class="jb-tip-list">${items}</ul>`;
    }

    if (printLabelSpan) {
      tipBtn = document.createElement('button');
      tipBtn.type = 'button';
      tipBtn.className = 'jb-tip';
      tipBtn.setAttribute('aria-expanded','false');
      tipBtn.setAttribute('aria-label','About print options');
      tipBtn.innerHTML = 'i';

      tipBubble = document.createElement('div');
      tipBubble.className = 'jb-tip-bubble';
      tipBubble.setAttribute('role','tooltip');
      tipBubble.hidden = true;
      tipBubble.innerHTML = buildTipContent();

      printLabelSpan.appendChild(tipBtn);
      printLabelSpan.appendChild(tipBubble);

      const hideTip = () => { tipBtn.setAttribute('aria-expanded','false'); tipBubble.hidden = true; };
      const showTip = () => { tipBtn.setAttribute('aria-expanded','true');  tipBubble.hidden = false; };
      const toggleTip = () => (tipBtn.getAttribute('aria-expanded') === 'true' ? hideTip() : showTip());

      tipBtn.addEventListener('mouseenter', showTip);
      tipBtn.addEventListener('mouseleave', hideTip);
      tipBtn.addEventListener('focus', showTip);
      tipBtn.addEventListener('blur', hideTip);
      tipBtn.addEventListener('click', (e)=>{ e.preventDefault(); toggleTip(); });

      root.addEventListener('click', (e) => {
        if (e.target !== tipBtn && !tipBubble.contains(e.target)) hideTip();
      });
    }

    /* ---------- Breakpoint nudge container ---------- */
    let nudgeEl = root.querySelector('.jb-nudge');
    if (!nudgeEl) {
      nudgeEl = document.createElement('div');
      nudgeEl.className = 'jb-nudge is-hidden';
      const grid = root.querySelector('.jb-calc-grid');
      (grid || root).insertAdjacentElement('afterend', nudgeEl);
    }

    /* ---------- Volume Tiers Toggle ---------- */
    if (elTiersToggle && elTiersPanel) {
      elTiersToggle.addEventListener('click', () => {
        const isOpen = elTiersPanel.classList.contains('is-open');
        elTiersPanel.classList.toggle('is-open', !isOpen);
        elTiersToggle.setAttribute('aria-expanded', !isOpen);
        elTiersToggle.querySelector('.jb-tiers-toggle-text').textContent = isOpen ? 'View all price breaks' : 'Hide price breaks';
      });
    }

    /* ---------- Calculator helpers ---------- */
    function firstCurrencyKey(){ const k = currencyKeys(); return k.length ? k[0] : null; }
    function fmt(amount, meta) {
      const code = meta?.code;
      const locale = meta?.locale;
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: code, maximumFractionDigits: 2 }).format(amount); }
      catch { return amount.toFixed(2); }
    }
    function nearestTier(qty, table) {
      const tiers = Object.keys(table.unit).map(Number).sort((a,b)=>a-b);
      for (let i = tiers.length - 1; i >= 0; i--) if (qty >= tiers[i]) return tiers[i];
      return tiers[0];
    }
    function nextTierAbove(qty, table) {
      const tiers = Object.keys(table.unit).map(Number).sort((a,b)=>a-b);
      for (let i = 0; i < tiers.length; i++) if (tiers[i] > qty) return tiers[i];
      return null;
    }
    
    /* ---------- Update savings display (in-box version) ---------- */
    const elUnitSavings = $('#jb-calc-unit-savings');
    const elTotalSavings = $('#jb-calc-total-savings');
    
    function updateSavings(meta, unitPrice, qty) {
      const rrp = meta.rrp || 0;
      
      if (!rrp || !unitPrice || unitPrice >= rrp || qty <= 0) {
        if (elUnitSavings) elUnitSavings.classList.add('is-hidden');
        if (elTotalSavings) elTotalSavings.classList.add('is-hidden');
        return;
      }
      
      const savingsPerUnit = rrp - unitPrice;
      const savingsPercent = Math.round((savingsPerUnit / rrp) * 100);
      const totalSavings = savingsPerUnit * qty;
      
      if (elUnitSavings) {
        elUnitSavings.innerHTML = `<span class="jb-savings-percent">${savingsPercent}% off</span> RRP`;
        elUnitSavings.classList.remove('is-hidden');
      }
      
      if (elTotalSavings) {
        elTotalSavings.innerHTML = `You save ${fmt(totalSavings, meta)}`;
        elTotalSavings.classList.remove('is-hidden');
      }
    }

    /* ---------- Build volume tiers list ---------- */
    function buildTiersList(meta, print) {
      if (!elTiersList) return;
      
      const tiers = Object.keys(meta.unit).map(Number).sort((a, b) => a - b);
      const surcharge = (meta.surcharge && meta.surcharge[print]) || 0;
      const formAnchor = root.dataset.formAnchor || '#enquiry';
      
      elTiersList.innerHTML = tiers.map((tier, idx) => {
        const unitPrice = (meta.unit[tier] || 0) + surcharge;
        const isLast = idx === tiers.length - 1;
        const qtyLabel = isLast ? `${tier}` : `${tier}–${(tiers[idx + 1] || tier) - 1}`;
        
        return `
          <div class="jb-tier-item">
            <span class="jb-tier-qty">${qtyLabel}</span>
            <span class="jb-tier-price">${fmt(unitPrice, meta)}</span>
          </div>
        `;
      }).join('');
      
      // 500+ tier links to enquiry form (uses dynamic anchor)
      elTiersList.innerHTML += `
        <a href="${formAnchor}" class="jb-tier-item jb-tier-item--contact jb-tier-contact-link">
          <span class="jb-tier-qty">500+</span>
          <span class="jb-tier-price">Contact us →</span>
        </a>
      `;
    }

    function updateRrp(meta, unitPrice) {
      if (!elRrpRow || !elRrp) return;
      const rrp = meta.rrp || 0;
      if (!rrp || !unitPrice || unitPrice >= rrp) { elRrpRow.classList.add('is-hidden'); return; }
      elRrp.textContent = fmt(rrp, meta);
      elRrpRow.classList.remove('is-hidden');
    }
    function toggleExVat(show) { if (elExVat) elExVat.classList.toggle('is-hidden', !show); }

    function setFigure(el, text){
      if (!el) return;
      if (el.textContent !== text){
        el.textContent = text;
        el.classList.remove('jb-fig-anim');
        void el.offsetWidth;
        el.classList.add('jb-fig-anim');
      }
    }

    let prevUnitPrice = null, priceSeeded = false;
    function flashCoBrandPill() {
      if (!coBrandPill) return;
      coBrandPill.classList.remove('is-flash');
      void coBrandPill.offsetWidth;
      coBrandPill.classList.add('is-flash');
    }
    coBrandPill && coBrandPill.addEventListener('animationend', () => coBrandPill.classList.remove('is-flash'));

    function flashImpactBar(elImpact){
      const card = elImpact?.closest('.jb-impact');
      if (!card) return;
      card.classList.remove('is-flash');
      void card.offsetWidth;
      card.classList.add('is-flash');
    }

    /* ---------- Main calc ---------- */
    function calc() {
      let curKey = elCurrency?.value;
      if (!curKey || !PRICING[curKey] || !PRICING[curKey].unit) {
        curKey = firstCurrencyKey(PRICING);
        if (elCurrency && curKey) elCurrency.value = curKey;
      }
      const curr = PRICING[curKey];
      if (!curr) return;

      const meta = { ...curr, code: curr.code || curKey, locale: curr.locale || undefined };

      const qtyVal = elQty?.value || '0';
      const isPlus = qtyVal === '500plus';
      const qty = isPlus ? MAX_SHOWN_QTY + 1 : parseInt(qtyVal, 10) || 0;

      const availablePrints = getPrintKeys();
      let print = elPrint?.value;
      if (!print || (availablePrints.length && !availablePrints.includes(print))) {
        print = availablePrints[0] || 'laser';
        if (elPrint) elPrint.value = print;
      }

      const impactKg = isPlus ? MAX_SHOWN_QTY * 0.1 : qty * 0.1;
      const plasticStraws = Math.round(impactKg * 2000); // 5kg = 10,000 straws
      const impactText = isPlus ? impactKg.toFixed(1) + '+ kg' : impactKg.toFixed(1) + ' kg';
      if (elImpact) { 
        elImpact.textContent = impactText; 
        flashImpactBar(elImpact); 
      }
      
      const elImpactBottles = $('#jb-calc-impact-bottles');
      if (elImpactBottles) {
        const formattedStraws = plasticStraws.toLocaleString();
        elImpactBottles.textContent = isPlus ? `≈ ${formattedStraws}+ plastic straws` : `≈ ${formattedStraws} plastic straws`;
      }

      const isQuote = qty > MAX_SHOWN_QTY;
      toggleExVat((meta.code === 'GBP') && !isQuote);

      buildTiersList(meta, print);

      if (isQuote) {
        const formAnchor = root.dataset.formAnchor || '#enquiry';
        const contactLink = `<a href="${formAnchor}" class="jb-quote-link">Contact us</a>`;
        if (elUnit) { elUnit.innerHTML = contactLink; elUnit.classList.add('jb-quote'); }
        if (elTotal) { elTotal.innerHTML = contactLink; elTotal.classList.add('jb-quote'); }
        if (elRrpRow) elRrpRow.classList.add('is-hidden');
        if (elUnitSavings) elUnitSavings.classList.add('is-hidden');
        if (elTotalSavings) elTotalSavings.classList.add('is-hidden');
        nudgeEl && nudgeEl.classList.add('is-hidden');
      } else {
        if (elUnit) elUnit.innerHTML = '';
        if (elTotal) elTotal.innerHTML = '';
        const tier  = nearestTier(qty, meta);
        const unit  = (meta.unit[tier] || 0) + ((meta.surcharge && meta.surcharge[print]) || 0);
        const total = unit * qty;

        setFigure(elUnit,  fmt(unit, meta));  elUnit?.classList.remove('jb-quote');
        setFigure(elTotal, fmt(total, meta)); elTotal?.classList.remove('jb-quote');

        updateRrp(meta, unit);
        updateSavings(meta, unit, qty);

        const nextTier = nextTierAbove(qty, meta);
        if (nudgeEl && nextTier && qty < nextTier) {
          const nextUnit = (meta.unit[nextTier] || 0) + ((meta.surcharge && meta.surcharge[print]) || 0);
          const savePer = unit - nextUnit;
          const delta   = nextTier - qty;
          if (savePer > 0) {
            nudgeEl.innerHTML = `Order <strong>${delta}</strong> more to hit the next price break (save <strong>${fmt(savePer, meta)}</strong>/unit)`;
            nudgeEl.classList.remove('is-hidden');
          } else {
            nudgeEl.classList.add('is-hidden');
          }
        } else {
          nudgeEl && nudgeEl.classList.add('is-hidden');
        }

        if (priceSeeded && (prevUnitPrice === null || Math.abs(unit - prevUnitPrice) > 1e-6)) {
          flashCoBrandPill();
        }
        prevUnitPrice = unit; priceSeeded = true;
      }

      persist();
    }

    /* ---------- Bind events ---------- */
    elCurrency && elCurrency.addEventListener('input', () => { persist(); calc(); });
    elQty      && elQty.addEventListener('input',      () => { persist(); calc(); });
    elPrint    && elPrint.addEventListener('input',    () => { persist(); calc(); });

    // Init
    calc();
  }

  /* ---------- Boot ---------- */
  function boot() {
    document.querySelectorAll('.jb-calc-root').forEach(enhance);
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  (function observeDynamicUpdates(){
    if (window.__jbCalcObserved) return;
    window.__jbCalcObserved = true;

    const mo = new MutationObserver((mutations) => {
      let shouldBoot = false;
      for (const m of mutations) {
        if (m.type === 'childList') {
          for (const n of m.addedNodes) {
            if (n.nodeType !== 1) continue;
            if (n.matches?.('.jb-calc-root') || n.querySelector?.('.jb-calc-root')) {
              shouldBoot = true; break;
            }
          }
        }
        if (m.type === 'attributes'
            && m.target.classList?.contains('jb-calc-root')
            && (m.attributeName === 'data-config' || m.attributeName === 'data-default-currency')) {
          delete m.target.dataset.ready;
          enhance(m.target);
        }
        if (shouldBoot) break;
      }
      if (shouldBoot) boot();
    });

    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-config','data-default-currency']
    });

    document.addEventListener('variant:changed', boot);
    document.addEventListener('product:change', boot);
  })();
})();